// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalHeader_header__3cv9o","closeWrapper":"ModalHeader_closeWrapper__2-VbZ","closeButton":"ModalHeader_closeButton__3uQqG"};